import { render, staticRenderFns } from "./MultiLineTextCell.vue?vue&type=template&id=5fe23bd0&scoped=true&"
import script from "./MultiLineTextCell.vue?vue&type=script&lang=js&"
export * from "./MultiLineTextCell.vue?vue&type=script&lang=js&"
import style0 from "./MultiLineTextCell.vue?vue&type=style&index=0&id=5fe23bd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe23bd0",
  null
  
)

export default component.exports